<template>
  <wui-btn
    v-if="!registered"
    variant="warning"
    state="alpha"
    disabled
    v-bind="buttonBind"
  >
    <wui-icon
      name="callDisabled"
      :title="$t('common.callsTemporarilyUnavailable')"
    />
  </wui-btn>
  <slot v-else />
</template>

<script lang="ts" setup>
import { WuiBtn, WuiIcon } from '@wui/common-library'
import { computed } from 'vue'

import { useWebRTC } from '@/entities/webrtc'

type ButtonSize = 24 | 32 | 40 | 48 | 72

const props = defineProps<{
  size?: ButtonSize
}>()

const buttonBind = computed(() => {
  if (props.size === undefined) {
    return {}
  }
  return { size: props.size }
})

const { registered } = useWebRTC()
</script>
